import React, { Component } from 'react'
import {connect} from 'react-redux'
import { withRouter } from 'react-router'
import { Header, Footer, Section } from '../../site_layout'
import ArticleLayout from 'app/site/structures/layout/article'
import GlobalComponent from 'app/site/structures/global'

@connect(state => state)
@withRouter
class Page extends Component {
  static defaultProps = {
    site: {}, // 站点元数据
    sections: [] // 站点版块
  }

  state = {
    pageType: this.props.pageType || 'theme/global'
  }

  params = () => {
    return new URLSearchParams(this.props.location.search)
  }

  // check dom height resize
  onElementHeightChange = (elm, callback) => {
    let lastHeight = elm.clientHeight, newHeight;
    (function run() {
      newHeight = elm.clientHeight;
      if (lastHeight !== newHeight) {
        callback();
      }
      lastHeight = newHeight;

      if (elm.onElementHeightChangeTimer) {
        clearTimeout(elm.onElementHeightChangeTimer);
      }

      elm.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
  }

  componentDidMount() {
    if (this.params().get('embedded') && window.parent) {
      this.onElementHeightChange(document.body, () => {
        window.parent.postMessage(JSON.stringify({event: "heightChanged", value: $(document).outerHeight()}), "*")
      })
    }
  }

  render() {
    const props = this.props
    const params = this.params()
    const embedded = params.get('embedded')
    return (
      <div>
        {
          !(embedded && params.get('header') === 'hide') &&
          <Header { ...props.site } preset={ props.site.theme.presets.header } />
        }

        {
          this.state.pageType.startsWith('theme/') &&
          props.sections.map((section, index) =>
            <Section key={ section.id + index } {...section} site={ props.site } />
          )
        }

        {this.state.pageType === 'page/article' &&  <ArticleLayout {...this.props} />}

        {
          this.state.pageType === 'theme/global' && props.sections.length === 0 &&
          <GlobalComponent {...this.props} />
        }

        {
          !(embedded && params.get('footer') === 'hide') &&
          <Footer { ...props.site } preset={ props.site.theme.presets.footer } />
        }
      </div>
    )
  }
}

export default Page


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/site_layout/page/index.js